<template>
  <div class="body">
    <div class="kong">
      <h2>
        <span class="kong_title">{{detail.title}}</span>
        <span class="kong_time">({{detail.time}})</span>
      </h2>
      <div>
        <span class="kong_speechmaker">{{detail.speechmaker}}</span>
        <span class="kong_speechUnit">{{detail.speechUnit}}</span>
      </div>
    </div>
    <div class="html" v-html="detail.lobbylap"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {

    // //添加退弹事件
    // window.addEventListener("popstate", function(e) {
    //   console.log('我监听到了浏览器的返回按钮事件啦',window.sessionStorage.getItem('selected'))
    //    window.sessionStorage.getItem('agendaUrl') + '?selected='+window.sessionStorage.getItem('selected')
    // });
  },
  methods: {
    init() {
      this.$axios
        .get(
          `/api/web/phone/content/agenda-detail/${this.$route.query.agendaId}`,
          {}
        )
        .then(res => {
          console.log("res", res);
          this.detail = res.data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.html {
  padding: 0 18px 30px;
  text-align: left;
  /deep/ p {
    width: 100%;
    font-size: 15px;
    color: #666666;
    // text-indent: 2em;
    margin: 1em 0em 1em 0em;
  }
  /deep/ img {
    display: block;
    width: 100% !important;
    height: auto;
  }
}
.kong {
  text-align: left;
  //   line-height: 24px;
  padding: 18px 18px 0px 18px;
  h2 {
    margin-bottom: 9px;
  }
  h2 .kong_time {
    font-size: 14px;
    color: #f10303;
  }
  h2 .kong_title {
    font-size: 17px;
    color: #232323;
  }
  .kong_speechmaker {
    font-size: 14px;
    color: #232323;
  }
  .kong_speechUnit {
    font-size: 12px;
    color: #666666;
  }
}
.box {
  background-color: #ededed;
  width: 100%;
  position: fixed;
  padding-bottom: 10px;
  padding-top: 10px;
}
.img {
  position: absolute;
  width: 12px;
  left: 18px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  img {
    width: 100%;
  }
}
.title {
  font-size: 16px;
  color: #232323;
}
.body {
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/Agenda.vue